import styled, { css } from 'styled-components';

import { breakpoints } from '@shared/constants';

export const ChatWrapper = styled.div(
    ({ theme: { palette } }) => css`
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: flex-start;
        margin-top: 32px;
        overflow-y: auto;
        padding-right: 10px;

        scrollbar-color: rgba(${palette.neutral.black}, 0.4);
        scrollbar-width: thin;

        /* Styling the scrollbar in Chrome and Safari */
        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(
                ${palette.neutral.black},
                0.4
            ); /* Set thumb color for Chrome and Safari */
        }

        &::-webkit-scrollbar-track {
            background-color: rgba(
                ${palette.neutral.black},
                0.1
            ); /* Set track color for Chrome and Safari */
        }

        @media (max-width: ${breakpoints.md}px) {
            margin-left: 16px;
            margin-right: 16px;
            margin-top: 0;
        }
    `,
);

export const MessagesWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: flex-start;
    padding-bottom: 48px;

    @media (max-width: ${breakpoints.md}px) {
        padding: 0;
    }
`;
